import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const Controls = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eb9kgxd0"
} : {
  target: "eb9kgxd0",
  label: "Controls"
})(process.env.NODE_ENV === "production" ? {
  name: "1o3nkn",
  styles: "margin-left:auto"
} : {
  name: "1o3nkn",
  styles: "margin-left:auto/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRyb2xzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNtQyIsImZpbGUiOiJDb250cm9scy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmV4cG9ydCBjb25zdCBDb250cm9scyA9IHN0eWxlZC5kaXYgYFxuICBtYXJnaW4tbGVmdDogYXV0bztcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Db250cm9scy5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});